@if (buttonImage === BackHeaderImageType.Default) {
  <app-icon-button (action)="SetAction($event)" [src]="'icons/32/arrow-left.svg'"></app-icon-button>
}
@if (buttonImage === BackHeaderImageType.Logo) {
  <app-image-button (action)="SetAction($event)" [style]="{width: '70px'}" src="assets/img/logo.svg" alt="Zurück zum Dashboard"></app-image-button>
}
<!-- Das quadratische Signet steht deutlich groesser als der Schriftzug: der
     ist 920x182 und liefert bei 70px Breite nur ~14px Hoehe.
     ⚠ 24px ist das Maximum. Die Zeichnung laeuft ueber die eigene viewBox
     hinaus (~1.3x der Breite), ab 32px haengt sie aus dem Header heraus. -->
@if (buttonImage === BackHeaderImageType.Symbol) {
  <app-image-button (action)="SetAction($event)" [style]="{width: '24px'}" src="assets/img/logo_symbol.svg" alt="Zurück zur Startseite"></app-image-button>
}
@if (buttonImage === BackHeaderImageType.None) {
  <span></span>
}
<div  class="{{ detailView ? 'label' : 'header-title'}}" (click)="SetAction({type: ButtonActions.Click})">{{ title }}</div>
@if (settingsOption) {
  <app-svg-icon
    class="settings"
    [src]="'icons/24/settings.svg'"
    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
    (click)="goToSettings()"
  ></app-svg-icon>
}
@if (filterOption !== FilterOption.hidden) {
  <app-svg-icon
    class="filter {{filterOption}}"
    [src]="'icons/24/filter.svg'"
    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
    (click)="SetAction({type: ButtonActions.Filter})"
  ></app-svg-icon>
}
